/**
 * Created by andrey on 01.12.2025
 */

const ConflictSnapshotView = cc.Node.extend({
    ctor: function (header, options = {}) {
        this.header = header;
        this.options = options;
        this.betters = options.betters || [];

        this._super();
        this.setAnchorPoint(0.5, 0.5);

        const styles = cleverapps.styles.ConflictSnapshotView;

        const progress = this.progress = this.createProgress();

        const padding = cc.padding(styles.padding);
        this.setContentSize(progress.width + padding.left + padding.right, progress.height + padding.top + padding.bottom);

        this.createBackground();

        if (options.local || options.remote && header.visited) {
            this.createStatus();
        }

        if (options.badge) {
            this.createBadge();
        }
    },

    createProgress: function () {
        const styles = cleverapps.styles.ConflictSnapshotView.progress;

        const background = cleverapps.UI.createScale9Sprite(bundles.conflict_window.frames.save_bg);
        background.setContentSize(styles.width, styles.height);

        const type = new cc.Sprite(this.options.remote ? bundles.conflict_window.frames.server : bundles.conflict_window.frames.local);
        type.setAlignment(styles.type);
        background.addChild(type);

        const levelBg = new cc.Sprite(bundles.conflict_window.frames.level_bg);
        levelBg.setAlignment(styles.level);
        background.addChild(levelBg);

        const levelLabel = cleverapps.UI.generateOnlyText(Messages.get("ConflictWindow.level"), cleverapps.styles.FONTS.SNAPSHOT_LEVEL);
        const levelValue = cleverapps.UI.generateOnlyText(this.header.level, this.betters.includes("level") ? cleverapps.styles.FONTS.SNAPSHOT_LEVEL_BETTER : cleverapps.styles.FONTS.SNAPSHOT_LEVEL);
        const level = new cleverapps.Layout([levelLabel, levelValue], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.level.margin
        });
        level.setAlignment(styles.level.text);
        levelBg.addChild(level);

        const items = this.createProgressItems();
        items.setAlignment(styles.items);
        background.addChild(items);

        background.setAlignment(styles);
        this.addChild(background);

        return background;
    },

    createProgressItems: function () {
        const styles = cleverapps.styles.ConflictSnapshotView.progress.items;

        const header = this.header;
        const betters = this.betters;

        const types = Object.keys(header).filter((key) => ["exp", "wands", "hard", "soft"].includes(key) && header[key] !== undefined);

        const items = types.map((type) => {
            const reward = new Reward(type, header[type]);
            return {
                icon: reward.getSmallIcon(),
                value: cleverapps.UI.generateImageText(reward.getAmount(), betters.includes(type) ? cleverapps.styles.FONTS.SNAPSHOT_ITEMS_BETTER : cleverapps.styles.FONTS.SNAPSHOT_ITEMS)
            };
        });

        let maxValueWidth = 0;
        let maxIconWidth = 0;

        for (const item of items) {
            if (item.value.width > maxValueWidth) {
                maxValueWidth = item.value.width;
            }
            if (item.icon.width > maxIconWidth) {
                maxIconWidth = item.icon.width;
            }
        }

        for (const item of items) {
            const iconPadding = Math.max(0, (maxIconWidth - item.icon.width) / 2);
            item.icon = cleverapps.UI.wrapWithPadding(item.icon, { left: iconPadding, right: iconPadding });
            item.icon.setContentSize(maxIconWidth, item.icon.height);
        }

        const itemsLayouts = items.map((item) => {
            const layout = new cleverapps.Layout([item.icon, item.value], {
                direction: cleverapps.UI.HORIZONTAL,
                margin: styles.margin
            });
            layout.setContentSize(maxIconWidth + maxValueWidth, layout.height);
            return layout;
        });

        return new cleverapps.Layout(itemsLayouts, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    createStatus: function () {
        const styles = cleverapps.styles.ConflictSnapshotView;

        let msg = Messages.get("ConflictWindow.local");

        if (this.options.remote) {
            const visited = this.header.visited;
            const value = Product.FormatTimePeriod(Date.now() - visited);
            const title = Messages.get(value.title, value.toReplace);
            msg = Messages.get("ConflictWindow.server", { time: title });
        }

        const status = cleverapps.UI.generateOnlyText(msg, cleverapps.styles.FONTS.SNAPSHOT_STATUS);
        status.fitTo(this.progress.width - styles.status.paddingX);
        status.setAlignment(styles.status);
        this.addChild(status);
    },

    createBadge: function () {
        const styles = cleverapps.styles.ConflictSnapshotView;

        const badge = new TileBadge({
            rotation: styles.badge.rotation,
            icon: new cc.Sprite(bundles.conflict_window.frames.badge_icon)
        });
        badge.setScale(styles.badge.scale);
        badge.setAlignment(styles.badge);
        this.addChild(badge);
    },

    createBackground: function () {
        const background = cleverapps.UI.createScale9Sprite(bundles.conflict_window.frames.tile_bg);
        background.setContentSize(this.width, this.height);
        background.setPosition(this.width / 2, this.height / 2);
        background.setLocalZOrder(-1);
        this.addChild(background);
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    SNAPSHOT_LEVEL: {
        size: 45,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    SNAPSHOT_LEVEL_BETTER: {
        name: "nostroke",
        size: 45,
        color: cleverapps.styles.COLORS.LIFE_GREEN,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    SNAPSHOT_ITEMS: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    SNAPSHOT_ITEMS_BETTER: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.GREEN
    },

    SNAPSHOT_STATUS: {
        size: 35,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    }
});

cleverapps.styles.ConflictSnapshotView = {
    padding: {
        x: 20,
        top: 5,
        bottom: 100
    },

    progress: {
        width: 390,
        height: 540,

        x: { align: "center" },
        y: { align: "top", dy: -5 },

        type: {
            x: { align: "center" },
            y: { align: "top", dy: -30 }
        },

        level: {
            x: { align: "center", dx: 8 },
            y: { align: "top", dy: -140 },

            margin: 10,

            text: {
                x: { align: "center", dx: -15 },
                y: { align: "center", dy: 10 }
            }
        },

        items: {
            margin: 5,

            x: { align: "center" },
            y: { align: "center", dy: -100 }
        }
    },

    badge: {
        x: { align: "right", dx: 45 },
        y: { align: "top", dy: 45 },

        rotation: 0,
        scale: 0.7
    },

    status: {
        paddingX: 40,
        x: { align: "center" },
        y: { align: "bottom", dy: 35 }
    }
};